var map = {
	"./ApprovalEditorOneMatchModal": 140,
	"./ApprovalEditorOneMatchModal.jsx": 140,
	"./ApprovalEditorResubmittedModal": 141,
	"./ApprovalEditorResubmittedModal.jsx": 141,
	"./AuthorStaleReviewsCompleteModal": 142,
	"./AuthorStaleReviewsCompleteModal.jsx": 142,
	"./ChannelAdminReviewArticlesModal": 143,
	"./ChannelAdminReviewArticlesModal.jsx": 143,
	"./CollectionApplicationApprovalModal": 144,
	"./CollectionApplicationApprovalModal.jsx": 144,
	"./DraftReadyForSubmissionModal": 145,
	"./DraftReadyForSubmissionModal.jsx": 145,
	"./GuestEditorModal": 146,
	"./GuestEditorModal.jsx": 146,
	"./Main": 147,
	"./Main.jsx": 147,
	"./ReferralProgramModal": 148,
	"./ReferralProgramModal.jsx": 148,
	"./ReviewerModal": 149,
	"./ReviewerModal.jsx": 149
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1745;
module.exports = webpackAsyncContext;